/** Read a file's bytes; FileReader covers browsers (and jsdom) without Blob.arrayBuffer. */
function readBytes(file: Blob): Promise<ArrayBuffer> {
    if (typeof file.arrayBuffer === 'function') return file.arrayBuffer();
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as ArrayBuffer);
        reader.onerror = () => reject(reader.error);
        reader.readAsArrayBuffer(file);
    });
}

/**
 * SHA-256 of an uploaded file as lowercase hex (F-12). The server hashes the same
 * bytes the same way (extractHipaaData, the identity override record), so the two
 * can be compared. Returns null when the browser can't read or hash the file: the
 * hash is a record-keeping field and must never block an upload.
 */
export async function sha256Hex(file: Blob): Promise<string | null> {
    try {
        const digest = await globalThis.crypto.subtle.digest('SHA-256', await readBytes(file));
        const hex = Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join('');
        return /^[0-9a-f]{64}$/.test(hex) ? hex : null;
    } catch {
        return null;
    }
}
